<template>
  <div class="flex flex-col items-start">
    <div class="w-full flex flex-col items-start" v-if="primeProperty">
      <div class="bg-yellow-lighter text-xs px-2 py-1 rounded-t">
        Prime Property
      </div>
      <div class="w-full flex items-center mb-4 py-2 px-2 bg-yellow-lighter rounded rounded-tl-none relative">
        <div class="w-6 h-6 bg-white rounded-full flex items-center justify-center absolute ml-1 mt-1 pin-l pin-t z-10">
          <icon name="prime_property" class="w-4 h-4 text-tertiary" :center="false" />
        </div>
        <div
          class="w-16 h-10 bg-cover mr-3 flex-no-shrink"
          :style="{'background-image': `url(${ primeProperty.main_photo || primeProperty.image })`}"
        >
        </div>
        <div class="w-full h-12 flex items-center justify-between">
          <div class="flex flex-col mr-4">
            <span class="text-xs mb-1 font-semibold">{{ primeProperty.address }}</span>
            <span class="text-xs">{{ primeProperty.price }}</span>
          </div>

          <button v-if="deletable" @click="$emit('prime:remove')">
            <icon name="delete" class="w-5 h-5" :center="false" />
          </button>
        </div>
      </div>
    </div>

    <div class="w-full relative mb-2">
      <div class="max-h-80 overflow-y-scroll" :class="{'pb-4': properties.length > 0}">
        <div v-for="property in properties" :key="property.id" class="w-full flex items-start px-2 py-4 border-t">
          <div
            class="w-16 h-10 bg-cover mr-3 flex-no-shrink"
            :style="{'background-image': `url(${ property.main_photo || property.image })`}"
          />
          <div class="w-full h-12 flex items-start justify-between">
            <div class="flex flex-col mr-4" :class="{'property-details': primeSelector}">
              <span class="text-xs mb-1 font-semibold">{{ property.address }}</span>
              <button v-if="primeSelector" @click="$emit('prime', property)" class="text-xs self-start border-2 border-tertiary rounded px-3 py-1 text-tertiary flex items-center flex-no-shrink">
                <icon name="prime_property" class="w-4 h-4 text-tertiary mr-1" :center="false" />
                Make prime property
              </button>
              <span class="text-xs">{{ property.price }}</span>
            </div>
          </div>

          <button v-if="deletable" class="self-center" @click="$emit('property:remove', property)">
            <icon name="delete" class="w-5 h-5" :center="false" />
          </button>
        </div>
      </div>
      <div v-if="properties.length > 1" class="absolute pin-b pin-l pin-r w-full h-10 scroll-fade border-b"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PropertyList',

  props: {
    primeProperty: {
      default: null
    },
    primeSelector: {
      type: Boolean,
      default: true
    },
    properties: {
      type: Array,
      default: Array
    },
    deletable: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {

    }
  }
}
</script>

<style scoped>
.property-details button {
  display: none;
}

.property-details:hover button + span {
  display: none;
}

.property-details:hover button {
  display: flex;
}

.scroll-fade {
  background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 25%, rgba(255,255,255,0) 100%);
}
</style>
